import { Component, OnInit, Inject, Optional } from '@angular/core';
import { ViewDialogsDbindicesService } from './view-dialogs-dbindices.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogsConfirmComponent } from '../../../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { EditDialogsDbindexfldsComponent } from '../../../dbindexflds/dialogs-dbindexflds/edit-dialogs-dbindexflds/edit-dialogs-dbindexflds.component';
import { Dbindexflds } from '../../../../../../../core/entities/dbindexflds.model';
import { Dbindices } from '../../../../../../../core/entities/dbindices.model';
import { TranslateService } from '@ngx-translate/core';
import { InternalHomeService } from '../../../../internal-home.service';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-view-dialogs-dbindices',
  templateUrl: './view-dialogs-dbindices.component.html',
  styleUrls: ['./view-dialogs-dbindices.component.scss']
})
export class ViewDialogsDbindicesComponent implements OnInit {

  /** Subscripción para el guardado de un dbindice */
  $guardar!: Subscription;
  dbindexfld: Dbindexflds = new Dbindexflds();

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public viewDialogsDbindicesService: ViewDialogsDbindicesService,
              @Optional() private dialogRef: MatDialogRef<ViewDialogsDbindicesComponent>,
              private translateService: TranslateService,
              private internalHomeService: InternalHomeService,
              private dialog: MatDialog) { this.viewDialogsDbindicesService.build(); }

  ngOnInit() {
    this.viewDialogsDbindicesService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla dbindexflds
  */
  private getAllDbindexflds(): void {
    this.loading = true;
    this.internalHomeService.allDbindexflds().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.loading = false;
        console.log("Error: " + error);
    });
  }


  /**
  * @description
  * Abre el dialog para crear un wsdefs
  * @param parametro Opcional. Wsdefs vacio.
  */
  public createDbindexfld(dbindexfld?: Dbindexflds) {
    var dbindices = new Dbindices();
    dbindices = this.data.dbindice;
    let titulochange = this.translateService.instant('CREACION.dbindexflds');
    let disabledDbindexfld = false;
    let disabledDbindex = false;
    dbindexfld = this.dbindexfld;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsDbindexfldsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { dbindexfld, titulochange, disabledDbindexfld, disabledDbindex, dbindices }
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if(result)
      setTimeout(() => {
        this.getAllDbindexflds();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un dbindexfld
  * @param dbindice Dbindexfld a eliminar
  */
  public removeDbindexfld(dbindexflds?: Dbindexflds) {
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_dbindices') }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loading = true;
        this.internalHomeService.removeDbindexflds(dbindexflds).subscribe(res => {
          console.log(res);
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * @description
  * Cierra el dialog dbindices view
  */
  aceptar() {
    this.dialogRef.close(true);
  }

}
